import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { questions } from '../config/questions';
import { QuestionStep } from './QuestionStep';
import { Preview } from './Preview';
import { Navbar } from './Navbar';
import { LandingPage } from './LandingPage';
import type { FormData } from '../types/form';

export function MainApp() {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState<FormData>({});
  const [showPreview, setShowPreview] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleNext = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      setShowPreview(true);
    }
  };

  const handlePrevious = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  const handleChange = (value: string) => {
    setFormData(prev => ({
      ...prev,
      [questions[currentStep].id]: value
    }));
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200">
      <Navbar />
      
      {!showForm ? (
        <LandingPage onStart={() => setShowForm(true)} />
      ) : showPreview ? (
        <Preview 
          data={formData} 
          onEdit={() => setShowPreview(false)} 
        />
      ) : (
        <AnimatePresence mode="wait">
          <QuestionStep
            key={questions[currentStep].id}
            question={questions[currentStep]}
            value={formData[questions[currentStep].id] || ''}
            onChange={handleChange}
            onNext={handleNext}
            onPrevious={handlePrevious}
            isFirst={currentStep === 0}
            isLast={currentStep === questions.length - 1}
            currentStep={currentStep + 1}
            totalSteps={questions.length}
          />
        </AnimatePresence>
      )}
    </div>
  );
}